import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { lazyWithErrorHandling } from "./utilities/functions";
import { NavMenu } from "@shopify/app-bridge-react";
import useBundleMixpanelHook from "./hooks/useBundleMixpanelHook";
import CartDrawerAdmin from "./apps/Cart/CartDrawerAdmin/CartDrawerAdmin";
import BundlesHomePage from "./apps/Bundles/BundlesHomePage";
const PlansComponent = lazyWithErrorHandling(() => import("./components/Plans"));
const SettingsWrapper = lazyWithErrorHandling(
    () => import("./apps/Bundles/OtherPages/SettingsWrapper/SettingsWrapper"),
);
const BundlesTable = lazyWithErrorHandling(() => import("./apps/Bundles/BundlesTable"));
const AnalyticsDashboard = lazyWithErrorHandling(() => import("./apps/Analytics/AnalyticsDashboard"));
// const KefiLabs = lazyWithErrorHandling(() => import("./apps/KefiLabs/KefiLabs"));
const TranslationsPage = lazyWithErrorHandling(
    () => import("./apps/Bundles/OtherPages/TranslationsPage/TranslationsPage"),
);
const ABTestDashboard = lazyWithErrorHandling(() => import("./apps/ABTest/ABTestDashboard"));
const ConnectWithTeam = lazyWithErrorHandling(() => import("./apps/ConnectWithTeam/ConnectWithTeam"));

function RoutesWrapper() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });
    }, [location]);

    const navigate = useNavigate();
    const { trackCtaClick } = useBundleMixpanelHook();

    const NAV_TAB_LABELS: Record<string, string> = {
        "/": "Bundles",
        "/bundles": "Upsell & Bundle Offers",
        "/slide-cart": "Slide Cart",
        "/analytics": "Analytics",
        "/ab-test": "A/B Tests",
        "/translations": "Translations",
        "/kefi-labs": "Kefi Labs",
        "/settings": "Settings",
        "/billing": "Billing",
        "/connect-with-team": "Connect with team",
    };

    function handleNavigation(e: React.MouseEvent<HTMLAnchorElement>) {
        const target = e.currentTarget as HTMLAnchorElement;
        e.preventDefault();
        const href = target.getAttribute("href") || "/";
        trackCtaClick({ cta: NAV_TAB_LABELS[href] || href, ctaType: "Navigation Menu" });
        navigate(href, { replace: true });
    }

    return (
        <div className={"globalWrapper"}>
            <NavMenu>
                <a href="/" rel="home" onClick={handleNavigation}>
                    Bundles
                </a>
                <a href={"/bundles"} onClick={handleNavigation}>
                    Upsell & Bundle Offers
                </a>
                <a href={"/slide-cart"} onClick={handleNavigation}>
                    Slide Cart
                </a>
                {/* <a href={"/ai-bundles"} onClick={handleNavigation}>
                    AI Suggestions
                </a> */}
                <a href="/analytics" onClick={handleNavigation}>
                    Analytics
                </a>
                <a href={"/ab-test"} onClick={handleNavigation}>
                    A/B Tests
                </a>
                {/* <a href={"/kefi-labs"} onClick={handleNavigation}>
                    Kefi Labs
                </a> */}
                <a href={"/settings"} onClick={handleNavigation}>
                    Settings
                </a>
                <a href={"/billing"} onClick={handleNavigation}>
                    Billing
                </a>
                <a href={"/translations"} onClick={handleNavigation}>
                    Translations
                </a>
                <a href={"/connect-with-team"} onClick={handleNavigation}>
                    Connect with team
                </a>
            </NavMenu>
            <Routes>
                <Route path={"/bundles"} element={<BundlesTable />} />
                <Route path={"/analytics"} element={<AnalyticsDashboard />} />
                <Route path={"/ab-test"} element={<ABTestDashboard />} />
                <Route path={"/billing"} element={<PlansComponent />} />
                <Route path={"/translations"} element={<TranslationsPage />} />
                <Route path={"/settings"} element={<SettingsWrapper />} />
                <Route path={"/slide-cart"} element={<CartDrawerAdmin />} />
                <Route path={"/connect-with-team"} element={<ConnectWithTeam />} />
                {/* <Route path={"/kefi-labs"} element={<KefiLabs />} /> */}
                <Route path={"/tab/:tab?"} element={<BundlesHomePage />} />
                <Route path={"/*"} element={<BundlesHomePage />} />
            </Routes>
        </div>
    );
}

export default RoutesWrapper;
